module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comp-parts-verify"
  }, [(!!_vm.messageData.title) ? _c('h2', {
    staticClass: "comp-parts-verify__subheader"
  }, [_vm._v(_vm._s(_vm.messageData.title))]) : _vm._e(), (!!_vm.messageData.message) ? _c('p', {
    staticClass: "comp-parts-verify__message"
  }, [_vm._v(_vm._s(_vm.messageData.message))]) : _vm._e(), (_vm.linkPath) ? _c('ExtLink', {
    attrs: {
      "text": _vm.linkText,
      "to": _vm.linkPath
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71f10564","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/verify/email/Email.vue
// module id = eac1abbde0d91ac15d30
// module chunks = 28